import { render } from "./BtnInserir.vue?vue&type=template&id=7f97ded9"
import script from "./BtnInserir.vue?vue&type=script&lang=js"
export * from "./BtnInserir.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__